import {
  LOAD_DATA,
  SET_LOADING,
  RESET_LOADING,
  ADD_TO_PLAYLIST,
  GET_PLAYLISTS,
  GET_MY_PLAYLISTS,
  CREATE_PLAYLIST_TITLE,
  SET_USER_TRACKS,
  UPLOAD_PROGRESS,
  SET_THEME,
  LOAD_USERS,
  LOAD_ALBUMS,
  LOAD_USER_ALBUMS,
} from "../types";
import UIkit from "uikit";
import { closeModal } from "../../utils/index";
import { dataActions } from "../types/data";
import { dataR } from "../types/reducers";

const tags = [
  "pop",
  "hip hop",
  "house",
  "afrobeats",
  "rhumba",
  "gospel",
  "reggae",
  "reggaeton",
  "rock",
  "dancehall",
  "blues",
  "rap",
  "soul",
  "bongo",
  "gengetone",
  "latin",
];

const initState: dataR = {
  list: [],
  loading: false,
  tags: tags,
  playlists: [],
  myPlaylists: [],
  users: [],
  albums: [],
  track: {
    covername: "",
    featured: [],
    id: "",
    likes: [],
    plays: [],
    src: "",
    tag: "",
    title: "",
    uid: "",
    username: "",
  },
  userTracks: [],
  subloading: true,
  uploading: false,
  lightTheme: true,
  fingerprint: null,
  userAlbums: [],
};

const dataReducer = (state = initState, action: dataActions): dataR => {
  const { type, payload } = action;
  let { playlists } = state;

  switch (type) {
    case LOAD_DATA:
      return {
        ...state,
        list: payload,
        loading: false,
      };
    case LOAD_ALBUMS:
      return {
        ...state,
        albums: payload,
      };
    case LOAD_USER_ALBUMS:
      return {
        ...state,
        userAlbums: payload,
      };

    case SET_LOADING:
      return {
        ...state,
        loading: true,
      };

    case RESET_LOADING:
      return {
        ...state,
        loading: false,
      };
    case GET_PLAYLISTS:
      return {
        ...state,
        playlists: payload,
        loading: false,
      };
    case GET_MY_PLAYLISTS:
      return {
        ...state,
        myPlaylists: payload,
        loading: false,
      };

    case CREATE_PLAYLIST_TITLE:
      const { title, tag, available, selected } = payload;
      playlists = Object.keys(selected).length
        ? [...playlists, { title, tag, public: available, songs: [selected] }]
        : [...playlists, { ...payload, songs: [] }];
      if (Object.keys(payload.selected).length) {
        UIkit.notification({
          message: `${selected.title} added to playlist`,
          status: `success`,
          timeout: 1000,
        });
      } else {
        UIkit.notification({
          message: `${title} created successfully`,
          status: `success`,
          timeout: 1000,
        });
      }

      return {
        ...state,
        playlists,
        loading: false,
      };
    case ADD_TO_PLAYLIST:
      if (payload.selected) {
        playlists = playlists.map((playlist) => {
          const { id } = playlist;
          if (id === payload.id) {
            playlist.tracks = [...playlist.tracks, payload.selected];
          }
          return playlist;
        });
        UIkit.notification({
          message: `${payload.selected.title} added to playlist`,
          status: `success`,
          timeout: 1000,
        });
      } else {
        UIkit.notification({
          message: `error adding to playlist`,
          status: `danger`,
          timeout: 1000,
        });
      }

      closeModal("playlists-modal");
      return {
        ...state,
        playlists,
        loading: false,
      };
    case SET_USER_TRACKS:
      return {
        ...state,
        userTracks: payload,
        subloading: false,
      };
    case LOAD_USERS:
      return {
        ...state,
        users: payload,
      };
    case UPLOAD_PROGRESS:
      return {
        ...state,
        uploading: payload,
        loading: false,
      };
    case SET_THEME:
      localStorage.setItem("isLight", `${payload}`);

      return {
        ...state,
        lightTheme: payload,
        loading: false,
      };
    default:
      return state;
  }
};

export default dataReducer;
